import { ExportColumnOptions } from '../types';
import resolveNonNegativeInteger from './resolveNonNegativeInteger';

const applyTextExportOptions = (
  value: string,
  exportOptions: ExportColumnOptions
): string => {
  const maxLength = resolveNonNegativeInteger(exportOptions.maxLength);
  // Max length trims the base value first so explicit prefix/suffix stay visible.
  const trimmedValue =
    maxLength === undefined ? value : value.substring(0, maxLength);

  return `${exportOptions.prefix}${trimmedValue}${exportOptions.suffix}`;
};

export default applyTextExportOptions;
